import { FormDateInline } from '@core/components/form';
import { FormControl } from '@core/utils/form';
import { TimeInput, toMoment } from '@core/utils/time';
import { GCDropdown } from '@modules/common/GCDropdown';
import React, { memo, ReactNode } from 'react';
import { DayPickerRangeControllerShape } from 'react-dates';
import { Button } from 'reactstrap';

export interface FormDropdownDateProps {
  control: FormControl<number>;
  options?: DayPickerRangeControllerShape;
  minDate?: TimeInput;
  maxDate?: TimeInput;
  children?: ReactNode;
  onChange?(date: number | undefined): void;
  clearable?: boolean;
}

export const FormDropdownDate = memo((props: FormDropdownDateProps) => {
  const { children, control, onChange, clearable = false, ...rest } = props;
  return (
    <GCDropdown target={children}>
      {setOpen => (
        <div className="p-4">
          <FormDateInline
            onChange={date => {
              setOpen(false);
              onChange && onChange(toMoment(date).endOf('day').unix());
            }}
            control={control}
            {...rest}
          />
          {clearable && (
            <Button
              color="dark"
              outline
              onClick={() => {
                setOpen(false);
                control.setValue(null);
                onChange && onChange(undefined);
              }}
            >
              Clear
            </Button>
          )}
        </div>
      )}
    </GCDropdown>
  );
});
